class DlFaqProductSupportBanner extends HTMLElement {
    constructor() {
        super();
        this.previewBtn = this.querySelector('.dl-banner-left-action-preview');
        this.closeBtn = this.querySelector('.close-btn');
        this.productModal = this.querySelector('.dl-product-support-banner-modal');
    }

    connectedCallback() {
        this.init();
    }

    init() {
        this.previewBtn.addEventListener('click', this.handlePreviewClick.bind(this));
        this.closeBtn.addEventListener('click', this.handleCloneClick.bind(this))
    }

    handlePreviewClick() {
        this.productModal.classList.add('dl-show');

        // 禁用页面滚动
        // document.body.style.overflow = 'hidden';
    }

    // 关闭弹窗
    handleCloneClick() {
        this.productModal.classList.remove('dl-show');
        // 恢复页面滚动
        // document.body.style.overflow = '';
    }
}
customElements.define('dl-product-support-banner', DlFaqProductSupportBanner);